import { DateInput, CurrencyInput } from '@components';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';
import { memo } from 'react';
import { nullIfEmpty } from '@utils/nullIfEmpty';
import { InputDiv, InputList, StyledInput } from '../styles';
import { PropsInputSingle, FlattenSingle } from './types';
import { onChangeSingle } from './utils';

type PurchaseInformationSingleProps = PropsInputSingle &
  FlattenSingle<'purchasedPrice' | 'purchasedFrom' | 'purchasedDate'>;
function PurchaseInformationSingle(props: PurchaseInformationSingleProps) {
  const {
    index,
    purchasedPrice,
    purchasedFrom,
    purchasedDate,
    onlyGroupEdits,
    setFormV,
  } = props;

  const purchasedPriceName = `equipments.${index}.purchasedPrice` as const;
  const purchasedFromName = `equipments.${index}.purchasedFrom` as const;
  const purchasedDateName = `equipments.${index}.purchasedDate` as const;

  return (
    <InputList className="three">
      <InputDiv>
        <CurrencyInput
          value={purchasedPrice ?? undefined}
          onChange={val => {
            onChangeSingle(purchasedPriceName, val ?? null, setFormV);
          }}
          disabled={onlyGroupEdits}
        />
      </InputDiv>
      <InputDiv>
        <StyledInput
          value={purchasedFrom ?? ''}
          onChange={e => {
            const cleanValue = nullIfEmpty.setValueAs(e.target.value);
            onChangeSingle(purchasedFromName, cleanValue, setFormV);
          }}
          disabled={onlyGroupEdits}
        />
      </InputDiv>
      <InputDiv>
        <DateInput
          borderColor={COLORS_FLAT[onlyGroupEdits ? 'n200' : 'n400']}
          value={purchasedDate}
          handleDateChange={e => {
            let convDate: Date | null = null;
            if (e) convDate = new Date(e);
            onChangeSingle(purchasedDateName, convDate, setFormV);
          }}
          disabled={onlyGroupEdits}
        />
      </InputDiv>
    </InputList>
  );
}
export default memo(PurchaseInformationSingle);
